/**
 * Оформление графиков: тёмная тема панели и янтарный акцент игры.
 */

export const COLORS = {
  amber: "#d99447",
  blue: "#5b8def",
  green: "#52c41a",
  red: "#ff6b6b",
  violet: "#a78bfa",
  grid: "#262b36",
  axis: "#8b90a0",
};

export const axisProps = {
  stroke: COLORS.axis,
  tick: { fill: COLORS.axis, fontSize: 12 },
  tickLine: false,
};

export const gridProps = { stroke: COLORS.grid, strokeDasharray: "3 3", vertical: false };

export const tooltipProps = {
  contentStyle: { background: "#161920", border: `1px solid ${COLORS.grid}`, borderRadius: 8 },
  labelStyle: { color: "#e8e9ee" },
  itemStyle: { padding: 0 },
};

const numberFormat = new Intl.NumberFormat("ru-RU");
export const fmt = (value: number) => numberFormat.format(value);

/** Доля в процентах с одним знаком; пусто, если делить не на что. */
export function percent(part: number, whole: number): string {
  if (!whole) return "—";
  return `${(Math.round((part / whole) * 1000) / 10).toLocaleString("ru-RU")}%`;
}
